import axios, {AxiosRequestConfig, AxiosResponse, AxiosError} from 'axios';
import {useAuthStore} from '../store/AuthStore';
import createAuthAxiosInstance from './createAuthAxiosInstance';
import createIoPayAxiosInstance from './createIoPayAxiosInstance';
import Keychain from 'react-native-keychain';

const createProductsAxiosInstance = () => {
  let config: AxiosRequestConfig = {
    baseURL: process.env.API_SALES_URL,
    //baseURL:'http://192.168.1.22:8000/api',
    timeout: 90000,
  };

  const instance = axios.create(config);

  instance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      const token = useAuthStore.getState().token;
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response.data?.errors && response.data?.errors.length) {
        throw {
          message: response.data.errors[0],
        };
      } else {
        return response;
      }
    },
    async (error: AxiosError) => {
      const originalRequest = error.config;
      const keychainCredentials = await Keychain.getGenericPassword();

      /* if (error.response?.status === 401) {
        console.log(`Erro 401 na requisição:: ${error?.config?.method?.toUpperCase()} ${error?.config?.baseURL}${error?.config?.url}`);
        useAuthStore.setState({ token: null });
      } else if (error.config) {
        console.log(`Erro ${error.response?.status} na requisição:: ${error.config.method?.toUpperCase()} ${error.config.baseURL}${error.config.url} `);
      } */

      if (error.response?.status === 400) {
        return Promise.reject(error);
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

const createCampaignsAxiosInstance = () => {
  let config: AxiosRequestConfig = {
    baseURL:  process.env.API_CAMPAIGNS_URL,
    timeout: 30000,
  };

  const instance = axios.create(config);

  instance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      const token = useAuthStore.getState().token;
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response.data?.errors && response.data?.errors.length) {
        throw {
          message: response.data.errors[0],
        };
      } else {
        return response;
      }
    },
    async (error: AxiosError) => {
      const originalRequest = error.config;
      const keychainCredentials = await Keychain.getGenericPassword();
      // console.log('original request ->', originalRequest)
      // if (error.response?.status === 404) {
      //   try {
      //     const response = await AuthService.refreshToken();
      //     const {access_token} = response;
      //     if (!access_token) {
      //       useAuthStore.setState({token: null});
      //     }
      //     useAuthStore.setState({token: access_token});
      //     originalRequest.headers.Authorization = `Bearer ${access_token}`;
      //     return instance(originalRequest);
      //   } catch (refreshError) {
      //     console.error('Erro ao renovar o token:', refreshError);
      //     useAuthStore.setState({token: null});
      //     throw new Error('Erro ao renovar o token');
      //   }
      // }
      // if (error.response?.status === 400) {
      //   const originalRequest = error.config;
      //   try {
      //     const response = await AuthService.refreshToken();
      //     const { access_token } = response;
      //     useAuthStore.setState({ token: access_token });
      //     originalRequest.headers.Authorization = `Bearer ${access_token}`;
      //     return instance(originalRequest);
      //   } catch (refreshError) {
      //     console.error('Erro ao renovar o token:', refreshError);
      //     throw new Error('Erro ao renovar o token');
      //   }
      // }
      if (error.response?.status === 401) {
        useAuthStore.setState({ token: null });
        return new Promise(() => {});
      }
      return Promise.reject(error);
    },
  );

  return instance;
};
export const withDebounce = (fn, delay = 300) => {
  let timer;
  let isRequestInProgress = false;

  return (...args) => {
    return new Promise((resolve, reject) => {
      if (isRequestInProgress) {
        console.log('Request already in progress, skipping duplicate call');
        return reject('Request already in progress');
      }

      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        try {
          isRequestInProgress = true;
          const result = await fn(...args);
          resolve(result);
        } catch (error) {
          reject(error);
        } finally {
          isRequestInProgress = false;
        }
      }, delay);
    });
  };
};
export default {
  createAuthAxiosInstance,
  createProductsAxiosInstance,
  createCampaignsAxiosInstance,
  createIoPayAxiosInstance,
};
